var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":50}}),_c('span',{staticClass:"mt-5"},[_vm._v("Loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }